export const openingDateConfidences = ['high', 'medium', 'low'] as const
export type OpeningDateConfidence = (typeof openingDateConfidences)[number]

export const DEFAULT_OPENING_DATE_CONFIDENCE: OpeningDateConfidence = 'medium'

export const openingDateConfidenceLabel: Record<OpeningDateConfidence, string> = {
  high: 'Vert — date sûre à 90 % (± 15 jours)',
  medium: 'Orange — projet confirmé, date à ± 2 mois',
  low: 'Rouge — projet incertain',
}
